function e(t) {
  return typeof t == "object" && t !== null;
}
export {
  e as i
};
//# sourceMappingURL=is-object-Bibs6Kbh.js.map
